const invitations = {
  pageName: 'Invitations',

  toast: {
    error: {
      default: 'Operation could not be completed.',
    },
    success: {
      delete: {
        default: 'Invitation/s deleted successfully',
      },
      resend: {
        default: 'Invitation/s resent successfully.',
      },
      create: {
        default: 'Success! Invitation sent successfully.',
      },
    },
  },

  table: {
    headers: {
      status: 'Status',
      email: 'Email',
      role: 'Role',
      invitedBy: 'Invited By',
    },
    actions: {
      delete: 'Delete',
      resend: 'Resend',
    },
    filters: {
      status: 'Status',
    },
  },

  form: {
    headers: {
      personalDetails: 'Personal Details',
      roles: 'User Roles',
    },
    fields: {
      firstName: 'First Name',
      lastName: 'Last Name',
      name: 'Name',
      phone: 'Phone',
      email: 'Email',
      role: 'Role',
      site: 'Site',
      supplier: 'Supplier',
    },
    select: 'Select',
    buttons: {
      addAccess: 'Add Site',
      sendInvitation: 'Send Invitation',
    },
  },

  deleteModal: {
    header: 'Delete Invitations',
    body: 'You are about to delete {{num}} Invitations.',
  },

  resendModal: {
    header: 'Resend Invitations',
    body: 'You are about to resend {{num}} Invitations.',
  },

  inviteModal: {
    header: 'Invite User',
    description: {
      new: 'Please insert email address and select preferred roles.',
      existing: 'Please select sites and preferred roles.',
    },
  },

  status: {
    pend: 'Pending',
    accepted: 'Accepted',
    expired: 'Expired',
  },

  isCompanyAdmin: 'Company Admin',
};

export default invitations;
